import { MessageCircle } from "lucide-react";

const PHONE = "919792684098";
const MSG = encodeURIComponent("Hi DIBRAL, I'm interested in AI automation for my business.");

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${PHONE}?text=${MSG}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="wa-float"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" strokeWidth={2.2} />
    </a>
  );
}
